import { SuperBonusMultiplier } from './SuperBonusMultiplier';
import { BaseScene } from './BaseScene';

export class BonusMultiplierScene extends BaseScene {
  private drawResult: any;
  constructor() {
    super('BonusMultiplierScene', true);
  }
  preload() {
    const config = window._po_gm.config;
    this.drawResult = config?.drawResult ? config?.drawResult : [];
  }
  createBody() {
    new SuperBonusMultiplier(this, this.screenWidth, this.screenHeight, this.drawResult);
  }
}
